import React from 'react';

export const NoInfo = ({displayMsg}) => {

  return(
    <div style={{fontFamily:'Oswald', backgroundColor: '', height: 200, display:'table', textAlign:'center', margin:'50px auto'}}>
      <span className="glyphicon glyphicon-ban-circle" style={{fontSize: 50}}></span>
      <h1>SORRY!</h1>
      <h4>{displayMsg}</h4>
    </div>
  )
};